import ng_fr_FR from '@angular/common/locales/fr';
import { CwtDeepPartial, ICwtCoreConfig } from '@cawita/core-front';
import { CwtDefaultAuthConfig } from '@cawita/core-front/auth';
import * as models from '@shared/models';
import { fr_FR } from 'ng-zorro-antd/i18n';
import { Constants } from '@server-shared';
import { environment } from '../../environments/environment';

export const CwtClientCoreConifg: CwtDeepPartial<ICwtCoreConfig> = {
    api: {
        apiUrl: environment.apiUrl,
        models: Object.values(models),
    },
    asset: {
        assetUrl: environment.assetUrl,
        protectedAssetPath: environment.protectedAssetPath,
        publicAssetPath: environment.publicAssetPath,
    },
    form: {
        passwordValidatorRegexp: Constants.regexp.password,
    },
    auth: {
        stateStorageKey: 'cwt-masak-sport-client-auth',
        api: {
            ...CwtDefaultAuthConfig?.api,
            registerEndpoint: 'user/subscribe'
        },
        navigation: {
            defaultRoute: ['/'],
            permissionDeniedRoute: ['/'],
            loginRoute: ['/auth', 'login'],
        },
    },
    i18n: {
        currentLocaleStorageKey: 'cwt-masak-sport-client-locale',
        defaultCurrencyCode: 'EUR',
        defaultLocale: 'fr',
        locales: [
            { localeId: 'fr', localeName: 'Français', ngLocaleData: ng_fr_FR, extra: { nzLocaleData: fr_FR } },
            // { localeId: 'en', localeName: 'English', ngLocaleData: ng_en_US, extra: { nzLocaleData: en_US } },
        ],
        resources: [
            { prefix: 'assets/i18n/', suffix: '.json' },
            { prefix: 'assets/i18n/', suffix: '.errors.json', key: 'errors' },
            { prefix: 'assets/i18n/', suffix: '.countries.json', key: 'countries' },
            { prefix: 'assets/i18n/', suffix: '.protocol.json', key: 'protocol' },
        ]
    }
}